import {
  ErrorLevel,
  ReplicantError,
  ReplicantErrorCode,
  ReplicantErrorSubCode,
} from '@play-co/replicant';
import { SyncActionAPI } from './types';

export type ReplicantActionError = Parameters<SyncActionAPI['reportError']>[0];

export function createReportableError(
  level: ErrorLevel,
  error: Error,
): ReplicantActionError {
  (error as ReplicantActionError).level = level;
  return error;
}

export type SerializableReplicantError = {
  message: string;
  code: ReplicantErrorCode;
  subCode?: ReplicantErrorSubCode;
};

/**
 * Convert a replicant error to a serializable format.
 * @param error - The error to convert.
 * @returns A serializable error object.
 */
export function toSerializableReplicantError(
  error: ReplicantError,
): SerializableReplicantError {
  return {
    message: error.message,
    code: error.code,
    subCode: error.subCode,
  };
}

/**
 * Convert a serializable error to a ReplicantError object.
 * @param serializable - The serializable error to convert.
 * @returns  An Error object.
 */
export function toReplicantError(
  serializable: SerializableReplicantError,
): ReplicantError {
  return new ReplicantError(
    serializable.message,
    serializable.code,
    serializable.subCode,
  );
}
